Vendd.Scripts.load(function () {
    var $form = $('.x-career-form'), $submitButton, form, formData, filedata;

    if ($form.length < 1)
        return;

    $submitButton = $('.js-submit-button', $form);

    form = $form.get(0);

    formData = {
        firstName: $("input[name='firstName']", $form).val() ? $("input[name='firstName']", $form).val() : "",
        lastName: $("input[name='lastName']", $form).val() ? $("input[name='lastName']", $form).val() : "",
        email: $("input[name='email']", $form).val() ? $("input[name='email']", $form).val() : "",
        phone: $("input[name='phone']", $form).val() ? $("input[name='phone']", $form).val() : "",
        address: $("input[name='address']", $form).val() ? $("input[name='address']", $form).val() : "",
        jobTitle: $("select[name='jobTitle']", $form).val() ? $("select[name='jobTitle']", $form).val() : "",
        regionTitle: $("select[name='regionTitle']", $form).val() ? $("select[name='regionTitle']", $form).val() : "",
        typeTitle: $("select[name='typeTitle']", $form).val() ? $("select[name='typeTitle']", $form).val() : "",
        message: $("textarea[name='message']", $form).val() ? $("textarea[name='message']", $form).val() : "",
        reCaptchaCode: "",
        careerFileUpload: ""
    };

    
    var captchaId = "careerCaptcha";
    var captchaWidgetId;
    var $captchaElement = $form.find("#" + captchaId);
    var $captchaContainer = $form.find('.recaptcha-container');
    var captchaEnabled = $captchaElement.length > 0 ? true : false;
    var $fileUploadElement = $form.find("#fileupload");
    var fileUploadEnabled = $fileUploadElement.length > 0 ? true : false;
    var invalidUpload = false;

    form.initRecaptcha = function () {

        if (!captchaEnabled)
            return;

        var sitekey = $captchaElement.data("sitekey");
        if (sitekey) {
            captchaEnabled = true;
            captchaWidgetId = grecaptcha.render(captchaId, {
                'sitekey': sitekey,
                'callback': form.recaptchaCallback
            });
            //accessibility fix
            $('#g-recaptcha-response').attr('aria-label', 'recaptcha response');
        }
    };

    form.recaptchaCallback = function () {
        form.validateRecaptcha();
    };

    form.resetRecaptcha = function () {
        // Website must only verify the user's reCAPTCHA response token (g-recaptcha-response) once. 
        // If a verify attempt has been made with a particular token, it cannot be used again. 
        // Call grecaptcha.reset() to ask the end user to verify with reCAPTCHA again.
        if (captchaEnabled)
            grecaptcha.reset(captchaWidgetId);
    };

    form.removeRecaptcha = function () {
        $captchaElement.remove();
    };

    form.validateRecaptcha = function () {
        if (!captchaEnabled)
            return true;

        formData.reCaptchaCode = $captchaElement.find('.g-recaptcha-response').val();

        var res = false;

        if (formData.reCaptchaCode) {
            $captchaContainer.find('.recaptcha-required').removeClass('error');
            res = true;
        }
        else {
            $captchaContainer.find('.recaptcha-required').addClass('error');
        }

        return res;
    };

    form.validateFileUpload = function () {
        if (!fileUploadEnabled)
            return true;

        if (invalidUpload)
            return false;

        if ($("#fileupload", $form).data("mandatoryfileupload") === true && $("#fileupload", $form).get(0).files.length === 0) {
            $('.fileupload-required', $form).show();
            $('.form-row.file', $form).addClass('with-error');

            return false;
        }

        return true;
    };

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.onSuccess = function (envelope) {
        form.loading(false);

        var data = envelope.message.data;

        if (data.success && data.code === "JobApplication_OperationSuccesful") {
            $('.js-error', $form).hide();
            $('.js-content', $form).hide();
            $('.js-success', $form).show();

            $('html,body').animate({ scrollTop: $('.js-success', $form).offset().top - 100 }, 400);

            form.reset();
        } else {
            $('.js-error', $form).show();
            form.resetRecaptcha();
        };
    };

    form.onFailure = function (envelope) {
        form.loading(false);

        $('.js-error', $form).show();
    };

    form.checkConsents = function () {
        var data = [];

        var checkboxes = $('.form-row.consent.checkbox');
        $.each(checkboxes, function (e, el) {
            var chkbx = $('.checkbox-wrapper input', el);
            data.push({ type: chkbx.attr('id'), source: 'Career Form', approved: chkbx.prop("checked") });
        });

        if (data.length > 0) {
            window.ConsentsManager.insertConsents(data);
        } else {
            if (filedata)
                filedata.submit();
            else
                form.submit();
        }

    };

    form.submit = function () {
        form.loading(true);

        $('input:not([type="checkbox"],[type="file"]), textarea:not([name="g-recaptcha-response"]),select', $form).each(function () {
            formData[$(this).attr('name')] = omitScriptTag($(this).attr('name') === 'email' ? $(this).val().trim() : $(this).val());
        });

        Vendd.MessageBus.publishAsync(form, new Vendd.Career.Messages.Submit(
            formData.firstName,
            formData.lastName,
            formData.email,
            formData.phone,
            formData.address,
            formData.message,
            formData.jobTitle,
            $form.data('jobid') || 0,
            formData.regionTitle,
            formData.typeTitle,   
            formData.careerFileUpload,
            formData.reCaptchaCode,
        ));
    };

    form.reset = function () {
        $('input[name="firstName"]', $form).val("");
        $('input[name="lastName"]', $form).val("");
        $('input[name="email"]', $form).val("");
        $('input[name="phone"]', $form).val("");
        $('input[name="address"]', $form).val("");
        $('select[name="jobTitle"]', $form).val("");
        $('select[name="regionTitle"]', $form).val("");
        $('select[name="typeTitle"]', $form).val("");
        $('textarea[name="message"]', $form).val("");
        $('input[name="PrivacyPolicy"]', $form).prop('checked', false);
        cf.reset();
    };

    form.clearUploadErrors = function () {
        $('.fileupload-required', $form).hide();
        $('.fileupload-invalid', $form).hide();
        $('.fileupload-exceeds-max-size', $form).hide();
        $('.form-row.file', $form).removeClass('with-error');
    };

    form.submitSelector = function () {
        if (filedata)
            filedata.submit();
        else
            form.submit();
    };

    $form.on('click', '.js-submit-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var val1 = cf.validate();
        var val2 = form.validateRecaptcha();
        var val3 = form.validateFileUpload();

        if (val1 && val2 && val3) {
            if (LhApp.Context.IsConsentsEnabled) {
                form.checkConsents();
            } else {
                if (filedata)
                    filedata.submit();
                else
                    form.submit();
            }
        } else {
            if ($('.form-row.with-error', $form).length > 0) {
                $('html,body').animate({ scrollTop: $('.form-row.with-error').first().offset().top - 100 }, 400);
            }
        }

    });

    $form.on('click', '.js-reset-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        form.reset();
    });

    $form.on('blur', 'input[name]:not([type="checkbox"]), textarea[name]', function (e) {
        form.setField($(this));
    });

    $form.on('keyup', 'input[name]:not([type="checkbox"]), textarea[name]', function (e) {
        form.setField($(this));
    });

    $form.on('change', 'select[name]', function (e) {
        form.setField($(this));
    });

    form.setField = function (field) {
        var fieldName = field.attr('name');
        cf.validate(fieldName);
    };

    //init validation options
    var validationOptions = {};

    //add required validations
    $.each($('input[data-required], textarea[data-required], select[data-required]', $form), function (e, el) {
        var inputName = $(el).attr('name');
        validationOptions[inputName] = { required: inputName + '-required' };
    });

    //add consent validations
    $.each($('div.consent.checkbox[data-required]'), function (e, el) {
        var consentType = $('input', el).attr('name');
        validationOptions[consentType] = { checkboxRequired: consentType + '-required' };
    });

    //add email validation
    if ($('input[name="email"]', $form).length > 0) {
        validationOptions.email = validationOptions.email || {};
        validationOptions.email = { ...validationOptions.email, ...{ isEmail: 'email-invalid' } };
    }

    //add phone validation
    if ($('input[name="phone"]', $form).length > 0) {
        validationOptions.phone = validationOptions.phone || {};
        if (venddProjectConfigs.phoneLocalizationEnabled) {
            validationOptions.phone = { ...validationOptions.phone, ...{ isValidPhoneLocalized: { validator: 'phone-invalid', config: { type: 'both' } } } };
        } else {
            validationOptions.phone = { ...validationOptions.phone, ...{ isPhoneNumber: 'phone-invalid' } };
        }
    }

    $form.validationEngine(validationOptions);
    var cf = $form.data('validationEngine');

    if (venddProjectConfigs.phoneLocalizationEnabled) {
        if ($('input[name="phone"]', $form).length > 0) {
            $('input[name="phone"]', $form).get(0).addEventListener("countrychange", function () {
                formData.phone = $(this).val();
                cf = $form.data('validationEngine');
                cf.validate('phone');
            });
        }
    }

    if ($(".view-terms", $form).length > 0) {
        $(".view-terms", $form).fancybox({
            touch: false,
            autoFocus: false
        });
    }

    var $consents = $('.form-row.consent input[type="checkbox"]', $form);

    $consents.on('click', function () {
        var fieldName = $(this).attr('name');

        cf.validate(fieldName);
    });

    $('.fileupload', $form).on('click', function () {
        $('.uploaded-file', $form).hide();
        $('.uploaded-file .text', $form).text('');
    });
    $('.fileupload', $form).fileupload({
        dataType: 'json',
        url: '/Engine/UploadCvFiles',
        autoUpload: false,
        replaceFileInput: false,
        fileInput: $("input:file"),
        multiple: false,
        singleFileUploads: true,
        done: function (e, data) {
            form.submit();
        },
        fail: function (e, data) {
            $('.fileupload-invalid', $form).show();
        },
        add: function (e, data) {

            form.clearUploadErrors();
            formData.careerFileUpload = "";

            var maxFileSize = $("#fileupload", $form).data("maxfilesize");

            var fileTypes = $("#fileupload", $form).data("acceptfiletypes");
            if (fileTypes) {
                var acceptFileTypes = "(\.|\/)(" + fileTypes + ")$";
                acceptFileTypes = new RegExp(acceptFileTypes, "i");
            }

            var extractExtension = /(?:\.([^.]+))?$/;

            if (acceptFileTypes && data.originalFiles[0]['type'].length && !acceptFileTypes.test(extractExtension.exec(data.originalFiles[0].name)[0])) {
                invalidUpload = true;
                $('.fileupload-invalid', $form).show();
                $('.form-row.file', $form).addClass('with-error');
            }
            else if (data.originalFiles[0]['size'] > maxFileSize) {
                invalidUpload = true;
                $('.fileupload-exceeds-max-size', $form).show();
                $('.form-row.file', $form).addClass('with-error');
            }
            else {
                invalidUpload = false;
                $('.uploaded-file', $form).show();
                $('.uploaded-file .text', $form).text(data.files[0].name);
                $('.uploaded-file .js-delete-file', $form).on('click', function (event) {
                    event.preventDefault();

                    form.clearUploadErrors();

                    $('.fileupload', $form).val('');
                    $('.uploaded-file', $form).hide();
                    $('.uploaded-file .text', $form).empty();

                    data.files.length = 0;

                    filedata = null;
                    formData.careerFileUpload = "";
                });
                filedata = data;
                formData.careerFileUpload = data.files[0].name;
            }
        }
    });

    Vendd.MessageBus.subscribe(Vendd.Career.Messages.SubmitSuccess, form, form.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.Career.Messages.SubmitFailure, form, form.onFailure);
    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.RecaptcaLoaded, form, form.initRecaptcha);
    Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertConsents, form, form.submitSelector);

});